import { Alert, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import type { ConsentSelection } from '../legalConfig';
import PrivacyLinksBlock from './PrivacyLinksBlock';

type TermsConsentFieldProps = {
  value: ConsentSelection;
  onChange: (nextValue: ConsentSelection) => void;
  errorMessages?: string[];
};

export default function TermsConsentField({ value, onChange, errorMessages = [] }: TermsConsentFieldProps) {
  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1" fontWeight={700}>
        Validation obligatoire
      </Typography>
      <PrivacyLinksBlock compact />
      <FormControlLabel
        control={
          <Checkbox
            checked={value.termsAccepted}
            onChange={(event) => onChange({ ...value, termsAccepted: event.target.checked })}
          />
        }
        label="J'ai lu et j'accepte les Conditions générales de Vente."
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={value.privacyAcknowledged}
            onChange={(event) => onChange({ ...value, privacyAcknowledged: event.target.checked })}
          />
        }
        label="J'ai pris connaissance de la Politique de confidentialité."
      />
      {errorMessages.map((message) => (
        <Alert key={message} severity="error" variant="outlined">
          {message}
        </Alert>
      ))}
    </Stack>
  );
}